<script setup lang="ts">
import { useMmText } from './text'
withDefaults(defineProps<{ status?: 'ready' | 'processing' | 'failed' | 'pro' | 'neutral' }>(), { status: 'ready' })
const { t } = useMmText()
</script>

<template><span class="badge" :class="status"><slot>{{ t(`mm.status.${status}`) }}</slot></span></template>
